/**
 * Contact Form 7: keep number fields to whole numbers and time fields to
 * digits and ":" (MCH-223, e.g. "How many times did someone try to insert
 * your IV cannula?"). Browsers let number inputs take "e", "+", "-" and "."
 * for scientific notation, which the audit questions never need.
 */
(function () {
  "use strict";

  const FIELDS = [
    { selector: ".wpcf7 input[type=number]", allowed: /[0-9]/, strip: /[^0-9]/g },
    { selector: ".wpcf7 input.walcf7-timepicker", allowed: /[0-9:]/, strip: /[^0-9:]/g },
  ];

  function ruleFor(input) {
    return FIELDS.find(function (field) {
      return input.matches(field.selector);
    });
  }

  // Block disallowed single characters as they're typed (navigation keys,
  // shortcuts and anything longer than one character, e.g. "Backspace", pass)
  document.addEventListener("keydown", function (e) {
    const rule = e.target instanceof HTMLInputElement && ruleFor(e.target);
    if (!rule || e.ctrlKey || e.metaKey || e.altKey || e.key.length !== 1) return;
    if (!rule.allowed.test(e.key)) e.preventDefault();
  });

  // Clean pasted or dropped text. A number input reports "" for invalid
  // content such as "1e", so check the raw text rather than the value.
  function cleanInsertedText(e, text) {
    const rule = e.target instanceof HTMLInputElement && ruleFor(e.target);
    if (!rule || !text) return;
    const cleaned = text.replace(rule.strip, "");
    if (cleaned === text) return;
    e.preventDefault();
    if (cleaned && e.target.type !== "number") {
      document.execCommand("insertText", false, cleaned);
    } else if (cleaned) {
      e.target.value = cleaned;
      e.target.dispatchEvent(new Event("input", { bubbles: true }));
    }
  }

  document.addEventListener("paste", function (e) {
    cleanInsertedText(e, (e.clipboardData || window.clipboardData).getData("text"));
  });

  document.addEventListener("drop", function (e) {
    cleanInsertedText(e, e.dataTransfer && e.dataTransfer.getData("text"));
  });
})();
